<template>
    <div class="view view-analytics-perfection">
        <HeaderAnalyticsPerfection />
        <AnalyticsPerfectionTotal />
        <AnalyticsNumDiamonds />
        <AnalyticsPerfectionDescription />

        <HeadingAnalyticsPerfection
            textHeading="Ünlü Özellikleri"
            textDesc="Her bir ünlü sesbirimdeki doğruluk serisi ilerlemen" />
        <AnalyticsDiamondCompletion
            :showPreloader="showPreloader"
            type="phonemicVowel"
            :phones="perfectionPhonesData" />
        <AnalyticsPhoneCompletion
            :showPreloader="showPreloader"
            type="phonemicVowel"    
            :phones="perfectionPhonesData" />

        <HeadingAnalyticsPerfection
            textHeading="Ünsüz Özellikleri"
            textDesc="Her bir ünsüz sesbirimdeki doğruluk serisi ilerlemen" />
        <AnalyticsDiamondCompletion
            :showPreloader="showPreloader"
            type="phonemicConsonant"
            :phones="perfectionPhonesData" />
        <AnalyticsPhoneCompletion
            :showPreloader="showPreloader"
            type="phonemicConsonant"    
            :phones="perfectionPhonesData" />
    
        <HeadingAnalyticsPerfection
            textHeading="Ünlü Değişkeleri"
            textDesc="Her bir ünlü değişkesindeki doğruluk serisi ilerlemen" />
        <AnalyticsDiamondCompletion
            :showPreloader="showPreloader"
            type="phoneticVowel"
            :phones="perfectionPhonesData" />
        <AnalyticsPhoneCompletion
            :showPreloader="showPreloader"
            type="phoneticVowel"    
            :phones="perfectionPhonesData" />

        <HeadingAnalyticsPerfection
            textHeading="Ünsüz Değişkeleri"
            textDesc="Her bir ünsüz değişkesindeki doğruluk serisi ilerlemen" />
        <AnalyticsDiamondCompletion
            :showPreloader="showPreloader"
            type="phoneticConsonant"
            :phones="perfectionPhonesData" />
        <AnalyticsPhoneCompletion
            :showPreloader="showPreloader"
            type="phoneticConsonant"    
            :phones="perfectionPhonesData" />

        <BtnChallenge />
        <BtnPracticeModes />
        <Navbar />
    </div>
</template>
<script>
    import HeaderAnalyticsPerfection from '@/components/HeaderAnalyticsPerfection.vue';
    import AnalyticsPerfectionTotal from '@/components/AnalyticsPerfectionTotal.vue';
    import AnalyticsNumDiamonds from '@/components/AnalyticsNumDiamonds';
    import AnalyticsPerfectionDescription from '@/components/AnalyticsPerfectionDescription';
    import HeadingAnalyticsPerfection from '@/components/HeadingAnalyticsPerfection';
    import AnalyticsDiamondCompletion from '@/components/AnalyticsDiamondCompletion.vue';
    import AnalyticsPhoneCompletion from '@/components/AnalyticsPhoneCompletion.vue';
    import BtnChallenge from '@/components/BtnChallenge.vue';
    import BtnPracticeModes from '@/components/BtnPracticeModes.vue';
    import Navbar from '@/components/Navbar.vue';

    export default {
        components: {
            HeaderAnalyticsPerfection,
            AnalyticsPerfectionTotal,
            AnalyticsNumDiamonds,
            AnalyticsPerfectionDescription,
            HeadingAnalyticsPerfection,
            AnalyticsDiamondCompletion,
            AnalyticsPhoneCompletion,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },
        
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            perfectionPhonesData(){
                if(this.showPreloader){
                    return;;
                }
                return this.$store.state.response.analyticsPerfection.perfectionPhonesData;                
            },
        },

        mounted(){
            document.body.style.backgroundColor = '#FFFFFF';
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsPerfectionPhones)
                .then(response => response.json())
                .then(perfectionPhonesData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'perfectionPhonesData',
                        data: perfectionPhonesData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPerfectionPhones, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(perfectionPhonesData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'perfectionPhonesData',
                        data: perfectionPhonesData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                })
            }
        },

        beforeUnmount(){
            document.body.style = "";
        }
    };
</script>
<style scoped src="@/css/views/view-analytics-perfection.css"></style>